import React from 'react';
import { BodyCard } from 'Common/components/Molecules/BodyCard';
import { BubbleIcon } from 'Common/components/Molecules/BubbleIcon';
import { Link } from 'Common/components/Atoms/Link';
import { Text } from 'Common/components/Atoms/Text';
import { Footer } from '../Shared/Footer';
import { FooterBullet } from '../Shared/FooterBullet';
import { Title } from '../Shared/Title';
import { mail } from 'fluent-mailto';
import { Email } from 'constants/email';
import { APPLICATION_SUBMITTED } from 'DisplayText/ReviewerOnboarding';
import { faClipboardCheck } from '@fortawesome/pro-solid-svg-icons';
import { logEvent, REVIEWER_APPLICATION_PENDING } from 'utils/analytics';

interface Props {
  name: string;
}

export function ApplicationSubmittedStep({ name }: Props): JSX.Element {
  React.useEffect(() => {
    logEvent(REVIEWER_APPLICATION_PENDING);
  }, []);

  const title =
    name === undefined
      ? APPLICATION_SUBMITTED.TITLE_BACKUP
      : APPLICATION_SUBMITTED.TITLE.replace('{USERNAME}', name);

  return (
    <div>
      <Title>{title}</Title>
      <BodyCard width={500} mx="auto">
        <BubbleIcon
          icon={faClipboardCheck}
          size="5x"
          p={5}
          py={4}
          mx="auto"
          mb={3}
        />
        <Text variant="body1" textAlign="center" mb={6}>
          {APPLICATION_SUBMITTED.EXPLANATORY_TEXT}
        </Text>
        <Footer>
          <FooterBullet>
            Questions? Please contact{' '}
            <Link
              href={mail
                .to(Email.SUPPORT)
                .subject(APPLICATION_SUBMITTED.EMAIL_SUBJECT)
                .build()}
            >
              {Email.SUPPORT}
            </Link>
          </FooterBullet>
        </Footer>
      </BodyCard>
    </div>
  );
}
